import React, { useEffect, useState } from "react";
import styles from "./GameScreen.module.css";
import { Button } from "./components/Button";
import { HomeIcon, ThumbDownIcon, ThumbUpIcon } from "./icons";
import { trackEvent } from "./trackEvent";
import { Locale } from "./data";

const AnimateFromTop: React.FC<{ text: string }> = ({ text }) => {
  const [isIn, setIsIn] = useState(false);

  useEffect(() => {
    setIsIn(true);
  }, []);

  return (
    <div
      className={`${styles.animateFromTop} ${
        isIn ? styles.animateFromTopIn : ""
      }`}
    >
      {text}
    </div>
  );
};

const AnimateFromBottom: React.FC<{ text: string }> = ({ text }) => {
  const [isIn, setIsIn] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsIn(true);
    }, 100);

    return function cleanup() {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div
      className={`${styles.animateFromBottom} ${
        isIn ? styles.animateFromBottomIn : ""
      }`}
    >
      {text}
    </div>
  );
};

const ThumbButtons: React.FC<{
  locale: Locale;
  character: string;
  activity: string;
}> = ({ locale, character, activity }) => {
  const [clickedThumbButton, setClickedThumbButton] = useState<
    "up" | "down" | null
  >(null);

  return (
    <div className={styles.thumbButtons}>
      <button
        className={`${styles.thumbButton} ${
          clickedThumbButton === "down" ? styles.thumbButtonRed : ""
        }`}
        onClick={() => {
          if (!clickedThumbButton) {
            setClickedThumbButton("down");

            trackEvent(
              `Clicked Meh: ${character} | ${activity} | ${locale.localeCode}`
            );
          }
        }}
      >
        <ThumbDownIcon /> {locale.text.meh1}
      </button>

      <button
        className={`${styles.thumbButton} ${
          clickedThumbButton === "up" ? styles.thumbButtonGreen : ""
        }`}
        onClick={() => {
          if (!clickedThumbButton) {
            setClickedThumbButton("up");

            trackEvent(
              `Clicked Fun combo: ${character} | ${activity} | ${locale.localeCode}`
            );
          }
        }}
      >
        {locale.text.fun1} <ThumbUpIcon />
      </button>
    </div>
  );
};

export const GameScreen: React.FC<{
  locale: Locale;
  character?: string;
  category?: string;
  activity?: string;
  onNext: () => void;
  onBack: () => void;
}> = ({ locale, character, category, activity, onNext, onBack }) => {
  return (
    <div className={styles.container}>
      <div className={styles.small}>
        <button onClick={() => onBack()} style={{ marginRight: 8 }}>
          <HomeIcon />
        </button>
        {locale.text.youHaveToImpersonate1}
      </div>

      <div className={styles.stack16}>
        {character && (
          <div className={styles.stack8}>
            <div className={styles.greySmall}>{category}</div>
            <AnimateFromTop key={character} text={character} />
          </div>
        )}

        {activity && (
          <div className={styles.stack8}>
            <AnimateFromBottom key={activity} text={activity} />
          </div>
        )}
      </div>

      <div className={styles.stack16}>
        <Button onClick={onNext}>{locale.text.next1}</Button>

        <ThumbButtons
          key={`${character} ${activity}`}
          locale={locale}
          character={character || "(None)"}
          activity={activity || "(None)"}
        />
      </div>
    </div>
  );
};
